var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag-item badge rounded-pill bg-info m-1 p-2"},[_vm._v(_vm._s(_vm.tagName))])}
var staticRenderFns = []

export { render, staticRenderFns }